/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as Yup from 'yup';
import { RequiredNumberSchema } from 'yup/lib/number';
export class TagValidation {
  static yupTagCategoryIdSchema(): RequiredNumberSchema<number | undefined> {
    return Yup.number().required();
  }
}
